import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiModule } from './ui/ui.module';
import { SafePipe } from '../pages/entryForm/DesignList/safePipe';

@NgModule({
  declarations: [SafePipe],
  imports: [
    CommonModule,
    UiModule
  ],
  exports:[
    SafePipe
  ]
})
export class SharedModule { }
